import React from 'react';
import classes from './TableRow.module.css';
import { TableCell } from '../TableCell/TableCell';
import { ColumnType } from '../types';
import chevronRight from '../../../assets/icons/chevron-right-2.svg'
import chevronDown from '../../../assets/icons/chevron-down.svg';

type TableRowProps<T> = {
  row: T;
  columns: ColumnType<T>[];
  index: number;
  style?: React.CSSProperties;
  cellStyle?: React.CSSProperties;
  isExpanded?: boolean;
  onExpandClick?: (index: number) => void;
  nestedCell?: boolean;
};

const TableRow = <T,>({ row, columns, style = {}, index, cellStyle = {}, isExpanded, onExpandClick, nestedCell = false, }: TableRowProps<T>) => {
  return (
    <tr className={classes.lightRow} style={style}>
      {nestedCell && (
        <TableCell align={'left'} style={cellStyle} />
      )}
      {onExpandClick && (
        <TableCell align={'left'} style={cellStyle}>
          <div onClick={() => onExpandClick(index)} style={{ width: 30, cursor: 'pointer' }}>
            {
              isExpanded ?
                <img src={chevronDown} alt={'chevron down'} /> :
                <img src={chevronRight} alt={'chevron right'} />
            }
          </div>
        </TableCell>
      )}
      {columns.map((column, _index) => (
        <TableCell align={column.align ?? 'left'} key={`${index}_${_index}`} style={cellStyle}>
          {column.renderer(row, _index)}
        </TableCell>
      ))}
    </tr>
  );
};

export { TableRow };
